import SectionHeading from "@/components/SectionHeading"
import PageCard from "@/components/PageCard"
import { createDataAttribute } from "next-sanity"

interface PagesFeedProps {
	heading?: string
	url?: string
	pages: any
	documentId: string
	_key: string
}

export default function PagesFeed({
	heading,
	url,
	pages,
	documentId,
	_key
}:PagesFeedProps) {
	return (
		<div className="section px-site"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}>

			<div className="mb-section--sm text-center">
				<SectionHeading heading={heading || `Our Services`} label="View All" url={url} />
			</div>

			<div className="site-grid gap-y-section--sm">

				{pages?.map((page, index) => (
					<div key={`${page?.slug}-${index}`} className={`col-span-full sm:col-span-3 md:col-span-4`}>
						<PageCard
							title={page?.title}
							subtitle={page?.summary}
							buttonLabel={`View ${page?.abbrName || "more"}`}
							// url={page?.parent?.slug ? `/${page?.parent?.slug}/${page?.slug}` : `/${page?.slug}`}
							image={page?.image}
						/>
					</div>
				))}

			</div>

		</div>
	)
}